import React from 'react';
import clsx from 'clsx';

const LandingContainer = ({ children, className }) => (
  <div className={clsx('landing-container', className)}>
    {children}
  </div>
);

export default LandingContainer;
